<template>
  <div v-if="protocol">
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <div class="px-4">
      <div class="d-flex flex-wrap align-center justify-space-between">
        <h1 class="text-h5 text-uppercase font-weight-bold">{{ pageTitle }}</h1>
        <v-btn color="primary" @click="$router.go(-1)">{{ $t('back') }}</v-btn>
      </div>

      <!-- Protocol Information Section -->
      <protocol-information
        :show-actions="showActions"
        :protocol="protocol"
        :sub-organization-id="subOrganizationId"
        @status-updated="fetchProtocolDetail"
      />
      <!-- Protocol Information Section -->

      <router-view :protocol="protocol"></router-view>
    </div>
  </div>
</template>

<script>
import EsgService from '@/_services/EsgService';
import ProtocolInformation from './ProtocolInformation.vue';
import LoadingMixin from "@/mixins/LoadingMixin";
export default {
  components: {
    ProtocolInformation,
  },
  mixins: [LoadingMixin],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('esgPlatform.esgPlatform'),
          disabled: false,
          to: { name: 'eudrDashboard' },
        },
        {
          text: this.$t('dashboard'),
          link: true,
          exact: true,
          disabled: true,
        },
      ],
      protocolId: this.$route.params.id,
      subOrganizationId: this.$route.params.subOrganizationId,
      protocol: null,
      respondentName: '',
    };
  },

  async created() {
    this.startLoading();
    await this.fetchProtocolDetail();
    await this.fetchRespondentName();
    this.stopLoading();
  },

  computed: {
    pageTitle() {
      if (this.respondentName) return this.respondentName;
      const routeName = this.$route.name;
      const user = JSON.parse(localStorage.getItem('user'));
      
      switch (routeName) {
        case 'ProtocolRecommendationsOfSubOrganization':
          return this.$t('esgPlatform.recommendations');
        default:
          return user?.user_organization?.name || 'Unknown Organization';
      }
    },

    showActions() {
      return this.$route.name === 'ProtocolDetailsOfSubOrganization';
    },
  },

  methods: {
    async fetchProtocolDetail() {
      this.startLoading();
      const response = await EsgService.getEsgProgressForRespondent('sub-organization', this.$route.params.subOrganizationId, this.$route.params.id);
      this.protocol = response.data;
      this.stopLoading();
    },
    async fetchRespondentName() {
      try {
        const cacheKey = `respondent-${this.protocolId}-${this.subOrganizationId}`;
        let cachedName = sessionStorage.getItem(cacheKey);
        
        if (cachedName) {
          this.respondentName = cachedName;
          return;
        }
        
        const response = await EsgService.getEsgStandardDetails(this.protocolId);
        const subOrganizations = response?.data?.subOrganizations || [];
        const match = subOrganizations.find(item => String(item._id) === String(this.subOrganizationId));
        
        if (match?.name) {
          this.respondentName = match.role === 'farmer' ? `${match.name} (Farmer)` : match.name;
          sessionStorage.setItem(cacheKey, this.respondentName);
        }
      } catch (error) {
        console.error('Error fetching respondent name:', error);
      }
    }
  }
};
</script>
